import React, { useRef } from 'react';
var VeltTextCommentToolbarCopywriter = function (props) {
    var defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-text-comment-toolbar-copywriter", { ref: ref, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltTextCommentToolbarCopywriter;
